/* eslint-disable @typescript-eslint/no-empty-interface */

import React from 'react';
import classnames from 'classnames';

import type { IBaseProps } from '@home/types/common';

import QRCodeIcon from '@gp/assets/svg/weekly-report/icon-qrcode.png';

interface IReportWallpaperFooterProps extends IBaseProps {}

const ReportWallpaperFooter: React.FC<IReportWallpaperFooterProps> = (props) => {
  const { style, className } = props;

  return (
    <footer style={style} className={classnames('dbg-dps-report-wallpaper-footer', className)}>
      <figure>
        <img src={QRCodeIcon} />
        <figcaption>
          <p>Please contact dps_prod@global.tencent.com</p>
          <p>if you have any questions.</p>
        </figcaption>
      </figure>
    </footer>
  );
};

export default ReportWallpaperFooter;
